import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders} from '@angular/common/http'
import { ActivatedRoute, Router } from "@angular/router";
import { gutil } from '../gutil';
import { config } from 'rxjs';

declare var Razorpay: any;
declare var jQuery: any;

@Injectable()
export class PaymentService{
    public user: any;
    public options:any;

    constructor(private http: HttpClient) {
        let thiis = this;
        this.options = {
            "key": "",
            "amount": 0,
            "name": "YourOwnROOM",
            "description": "",
            "image": "http://yourownroom.com/wp-content/uploads/2015/07/header-logo-light.png",
            "prefill": {
                "name": "",
                "email": ""
            },
            "notes": {
                "reference_no": "",
                "address": ""
            },
            "theme": {
                "color": "#F37254"
            },
            "handler": function (response){
                //location.href = "/payment/gtwresponse?MerchantRefNo=<?=$reqdata['reference_no']?>&TransactionID=" + response.razorpay_payment_id;
                thiis.successCallback(thiis,response.razorpay_payment_id)
            },
            "modal": {
                "ondismiss": function(){
                    //location.href = "/payment/gtwresponse?MerchantRefNo=<?=$reqdata['reference_no']?>";
                    thiis.successCallback(thiis,"");
                }
            }
        };
    }

    private successCallback(thiis:any, payment_id:string) {
        let headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded'});
        
        let options =  {headers: headers };

        let params = new URLSearchParams();
        params.append('PaymentID', payment_id);
        params.append('TransactionID', payment_id);
        params.append('MerchantRefNo', this.options.notes.reference_no);
        params.append('appreq', payment_id);

        let paramsString = params.toString();
        thiis.http.post(gutil.devapiUrl + '/api/v1/payment/gatewayresponse?api_token=' + this.user.api_token, paramsString, options)
            .subscribe(
                (data: any) => {
                    if(data.obj == -1){
                        gutil.showMessages([{"code": "custom_message", "message": "Please contact our support team for details, looks like no property linked to your account."}]);
                    }
                },
                (err:any) => console.error(err)
            );
    };

    public initiatePayment(id:number,amount:number,typ:string,message:string,couponcode:string,coupondata:any,gatewaycheck:any){
        this.user = gutil.user;
        var pyData = {};
        pyData["type"] = typ;
        pyData["typeid"] = id;
        pyData["amount"] = amount;
        pyData["name"] = this.user.name;
        pyData["address"] = this.user.addressl1;
        pyData["city"] = this.user.city;
        pyData["state"] = this.user.state;
        pyData["postal_code"] = this.user.zipcode;
        pyData["country"] = "IND";
        pyData["email"] = this.user.email;
        pyData["phone"] = this.user.phone;
        pyData["ship_name"] = this.user.name;
        pyData["ship_address"] = this.user.addressl1;
        pyData["ship_city"] = this.user.city;
        pyData["ship_state"] = this.user.state;
        pyData["ship_postal_code"] = this.user.zipcode;
        pyData["ship_country"] = "IND";
        pyData["ship_phone"] = this.user.phone;
        pyData["coupon_id"] = (coupondata != undefined) ? coupondata.id : "";
        pyData["coupon_code"] = couponcode;
        pyData["tamnt"] = (coupondata != undefined) ? coupondata.total : "";
        pyData["damnt"] = (coupondata != undefined) ? coupondata.discount : "";
        // console.log(pyData);
        if(message===undefined){
            message = "Proceed for payment of Rs." + amount;
        }
        var confirm = window.confirm(message);
        var thiis = this;
        if(confirm)
        {
            let headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded'} );
            let options =  ({headers: headers});
            let params = new URLSearchParams();
            for(let x in pyData){
                params.append(x, pyData[x]);
            }
            let paramsString = params.toString();
            //let url = '/api/v1/payment/initiate?api_token=';
            let url = '';
            if(gatewaycheck == undefined || gatewaycheck == 'paytm'){
                url ='';
                window.open("https://m.p-y.tm/YOR", "_blank");
            }
            if(typeof gatewaycheck != undefined && gatewaycheck == 'payum'){
                url = '/api/v1/payment/initiate/payum?api_token=';
            }
            if(typeof gatewaycheck != undefined && gatewaycheck == 'razor'){
                url = '/api/v1/payment/initiate?api_token=';
            }
            if(url!==''){
                // console.log(gutil.devapiUrl + url , this.user.api_token , options);
                this.http.post(gutil.apiUrl + url + this.user.api_token, paramsString, options)
                    .subscribe(
                    (data: any) => {
                        if(data.obj == -1){
                            console.log('data.obj -1 error');
                            // jQuery('#pay_now').removeAttr("disabled");
                            // gutil.showMessages([{"code": "custom_message", "message": "Please contact our support team for details looks like no property linked to your account."}]);
                        }
                        else{
                            if(data.obj.gateway == 'razorpay'){
                                this.initiatePaymentRazorpay(data.obj.paymentreq);
                                // console.log("init razorpay");
                            }
                            else{
                                // this.initiatePaymentPayUMoney(data.obj.paymentreq);
                                console.log("init payu");
                            }
                        }
                    },
                    (err:any) => {
                        console.error(err);
                        jQuery('#pay_now').removeAttr("disabled");
                    }
                );

            }
            else{
                jQuery('#pay_now').removeAttr("disabled");
            }
        }
    };

    public initiatePaymentRazorpay(paymdata: any){
        this.options.key = paymdata.api_key;
        this.options.amount = paymdata.amount * 100;
        this.options.description = paymdata.description;
        this.options.prefill.name = paymdata.name;
        this.options.prefill.email = paymdata.email;
        this.options.notes.reference_no = paymdata.reference_no;
        this.options.notes.address = paymdata.address + " " + paymdata.city + " " + paymdata.state + " " + paymdata.country + " - " + paymdata.postal_code;

        var rzp1 = new Razorpay(this.options);
        rzp1.open();
    }
}